import { FREQUENCY } from '@funnels/constants';

export default function getFrequencyLabel(frequency: FREQUENCY) {
  switch (frequency) {
    case FREQUENCY.FORTNIGHTLY:
      return 'fortnightly';
    case FREQUENCY.WEEKLY:
      return 'weekly';
    case FREQUENCY.MONTHLY:
      return 'monthly';
    case FREQUENCY.YEARLY:
      return 'yearly';
    default:
      return '';
  }
}
